export class FormulaCatalogoResolverRequest {
    criterios: Record<string, string[]> = {};
}
